// Which PayClear host this bundle is running on. The same build is served on
// every host (one bucket, one CloudFront distribution):
//
//   site  tspayclear.com, www.tspayclear.com, dev.tspayclear.com   landing + marketing
//   app   app.tspayclear.com, app.dev.tspayclear.com               the app
//   combined  anything else (localhost, *.cloudfront.net)          both, as before the split
//
// The edge (infra/cdk/lib/edge/host-router.js) 301s app paths on a site host
// to the app host. This file mirrors that for client-side navigation and in
// case the edge function is not attached (e.g. during a rollback).

// Landing paths that stay on the site host. Must match LANDING_PATHS in
// infra/cdk/lib/edge/host-router.js (infra/cdk/test/host-router.test.js checks it).
export const SITE_PATHS = ["/"];

const SITE_TO_APP = {
  "tspayclear.com": "app.tspayclear.com",
  "www.tspayclear.com": "app.tspayclear.com",
  "dev.tspayclear.com": "app.dev.tspayclear.com",
};
const APP_TO_SITE = {
  "app.tspayclear.com": "tspayclear.com",
  "app.dev.tspayclear.com": "dev.tspayclear.com",
};

export function hostKind(hostname = window.location.hostname) {
  const h = (hostname || "").toLowerCase();
  if (SITE_TO_APP[h]) return "site";
  if (APP_TO_SITE[h]) return "app";
  return "combined";
}

export function isSitePath(pathname) {
  let p = (pathname || "/").toLowerCase();
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  return SITE_PATHS.includes(p);
}

// Absolute URL on the app host (relative when this host already serves the app).
export function appUrl(path = "/", hostname = window.location.hostname) {
  const app = SITE_TO_APP[(hostname || "").toLowerCase()];
  return app ? `https://${app}${path}` : path;
}

// Absolute URL on the site (landing) host (relative when this host serves it).
export function siteUrl(path = "/", hostname = window.location.hostname) {
  const site = APP_TO_SITE[(hostname || "").toLowerCase()];
  return site ? `https://${site}${path}` : path;
}
